export default __webpack_public_path__ + "static/media/Booth.d8c5be37.svg";